export default {
  'home.title': 'VPAuto live',
  'home.menu.auctioneer': 'Commissaire priseur',
  'home.menu.customer': 'Client',
  'home.menu.hall': 'Salle des ventes',
  'home.menu.operator': 'Opérateur',
  'home.menu.salesperson': 'Commercial',
  'home.menu.sliderimages': 'Slider images',
  'operator.dashboard.openLot': 'Ouvrir le lot',
  'operator.dashboard.openAuctions': 'Ouvrir les enchères',
  'operator.dashboard.pause': 'Mettre en pause',
  'operator.dashboard.restart': 'Restaurer la vente',
  'operator.dashboard.close': 'Clôturer le lot',
  'operator.dashboard.end': 'Terminé',
  'operator.dashboard.ok': 'Ok',
  'operator.dashboard.defaultStep': 'Pas par défaut',
  'operator.dashboard.editPrice': 'Modifier le prix de départ',
  'operator.dashboard.interauctionBid': 'Enchérir Interenchères',
  'operator.dashboard.startTimer': 'Chrono de départ',
  'operator.dashboard.auctionTimer': 'Chrono des enchères',
  'operator.dashboard.hallBid': 'Enchérir salle',
  'operator.auctions.origin': 'Origine',
  'operator.auctions.buyer': "Nom de l'acheteur",
  'operator.auctions.company': 'Société',
  'operator.auctions.user.country': 'Pays',
  'operator.auctions.user.type': 'Type',
  'operator.auctions.user.type.user': 'Particulier',
  'operator.auctions.user.type.society': 'Société',
  'operator.auctions.user.type.pro': 'PRO',
  'operator.auctions.amountHF': 'Montant HF',
  'operator.auctions.amount': 'Montant',
  'operator.auctions.maxBid': 'Offre max',
  'operator.autions.editPrice.modal.title': 'Modifier le prix de départ',
  'operator.autions.editPrice.modal.label': 'Prix de départ',
  'auctioneer.dashboard.status.open': 'En cours',
  'auctioneer.dashboard.status.close': 'Terminé',
  'auctioneer.dashboard.reservePrice': 'Prix de réserve',
  'auctioneer.dashboard.nextAuction': 'Prochaine enchère',
  'auctioneer.dashboard.nextAuction.step': '(Pas de {step} €)',
  'auctioneer.dashboard.reduceReservePrice': "Baisser le prix de réserve à l'enchère en cours",
  'auctioneer.dashboard.award': 'Adjuger',
  'lot.toolbox.label': 'Lot N° {number}',
  'lot.toolbox.next.a11yLabel': 'Lot suivant',
  'lot.toolbox.shutdown.a11yLabel': 'Clôturer la vente',
  'lot.toolbox.previous.a11yLabel': 'Lot précédent',
  'lot.toolbox.first.a11yLabel': 'Aller au premier lot',
  'lot.toolbox.last.a11yLabel': 'Aller au dernier lot',
  'lot.toolbox.modal.changeLot.title': 'Choisissez un lot',
  'lot.toolbox.modal.changeLot.validate': 'Valider',
  'lot.toolbox.modal.changeLot.close': 'Fermer',
  'lot.toolbox.modal.changeLot.error': 'Aucun lot ne correspond à votre recherche',
  'lot.toolbox.modal.closeSale.title': 'Êtes-vous sûr de vouloir clôturer cette vente ?',
  'lot.toolbox.modal.closeSale.yes': 'Oui',
  'lot.toolbox.modal.closeSale.no': 'Non',
  'lot.toolbox.modal.closeAuction.title': 'Supprimer la dernière enchère ?',
  'lot.toolbox.modal.closeAuction.yes': 'Oui',
  'lot.toolbox.modal.closeAuction.no': 'Non',
  'lot.toolbox.modal.closeLot.title':
    'Le montant de la meilleure enchère est inférieur à celui de la réserve.',
  'lot.toolbox.modal.closeLot.subtitle': 'Souhaitez-vous adjuger ?',
  'lot.toolbox.modal.closeLot.yes': 'Oui',
  'lot.toolbox.modal.closeLot.no': 'Non',
  'lot.toolbox.modal.pauseLot.choseTime': 'Choisissez une heure de reprise',
  'lot.toolbox.modal.pauseLot.grabTime': 'Saisissez une heure de reprise',
  'lot.toolbox.modal.pauseLot.validate': 'Valider',
  'salesperson.header.userCounter.spectator.label':
    '{value, plural, zero {spectateur} one {spectateur} other {spectateurs}}',
  'salesperson.header.userCounter.spectator.title':
    'Total des clics sur le bouton du mode spectateur.',
  'salesperson.header.userCounter.identified.label':
    '{value, plural, zero {identifié} one {identifié} other {identifiés}}',
  'salesperson.header.userCounter.identified.title': 'Total des identifiés de la journée.',
  'salesperson.header.userCounter.loggedIn.label':
    '{value, plural, zero {connecté} one {connecté} other {connectés}}',
  'salesperson.header.userCounter.loggedIn.title':
    'Anonymes et identifiés actuellement sur le Live.',
  'salesperson.header.title': 'Vente live de {name}',
  'salesperson.dataTable.company.yes': 'Oui ({name})',
  'salesperson.dataTable.company.no': 'Non',
  'salesperson.dataTable.column.name': 'Nom',
  'salesperson.dataTable.column.email': 'Email',
  'salesperson.dataTable.column.country': 'Pays',
  'salesperson.dataTable.column.lastConnectedAt': 'Connexion',
  'salesperson.dataTable.column.isPro': 'Pro',
  'salesperson.dataTable.column.auctions': 'Enchères',
  'salesperson.header.logout.label': 'Se déconnecter',
  'hall.lotNumber.label': 'Nr. {number}',
  'hall.newPrice': 'Nieuwe prijs* : {price}',
  'hall.taxes.label': 'BTW',
  'hall.taxes.yes': 'JA',
  'hall.taxes.no': 'NEEN',
  'client.attr.auction.loading': 'Laden...',
  'client.attr.vehicle.photo_next': 'Volgende afbeelding',
  'client.attr.vehicle.photo_previous': 'Vorige afbeelding',
  'client.auction.bid': 'Bieden met',
  'client.auction.fees_extra': 'Bijkomende administratiekosten: € {handlingFees}',
  'client.auction.fees_included': 'Inclusief verkoopkosten',
  'client.auction.few_moments': 'binnen enkele ogenblikken',
  'client.auction.losing': 'U heeft niet het winnende bod',
  'client.auction.lost_text': 'U heeft de veiling niet gewonnen.',
  'client.auction.lot_closed': 'Set gesloten',
  'client.auction.next_auction': 'Volgende veiling',
  'client.auction.opening_in': 'Opening van veiling',
  'client.auction.register_to_bid': 'Schrijf u in om te bieden',
  'client.auction.same_amount': 'Zelfde veiling voor dit bedrag',
  'client.auction.seconds': 'Second(en)',
  'client.auction.sold': 'Toegewezen',
  'client.auction.starting_price': 'Inzetprijs',
  'client.auction.vat_excluded': 'excl. belasting',
  'client.auction.winning': 'U heeft het winnende bod',
  'client.auction.won_text1': 'U heeft het winnende bod',
  'client.auction.won_text2': 'We nemen contact met u op.',
  'client.auction.you': 'U',
  'client.auction.salle': 'Zaal',
  'client.auction.interenchères': 'Web',
  'client.auction.web': 'Web',
  'client.auction.live': 'Web',
  'client.auction.oa': 'Web',
  'client.footer.catalog': 'Terug naar de catalogus',
  'client.footer.footnote.one': 'Bijkomende administratiekosten: € {handlingFees} incl. btw',
  'client.footer.footnote.three': 'Codex-referentie op releasedatum of originele factuur',
  'client.footer.footnote.two':
    'Prijs pro rata temporis, of marktprijs, of geschatte notering, gegeven bij wijze van indicatie, niet de verantwoordelijkheid van VPauto innemend',
  'client.footer.vehicle_link': 'Details van de set',
  'client.header.live_from': 'Live vanuit',
  'client.header.logout': 'Afmelden',
  'client.popup.body.first': 'U gaat de zaal binnen als bieder.',
  'client.popup.body.second':
    'Door te klikken op de knop "Bieden" doet u een bod waaraan u vast zit.',
  'client.popup.body.third':
    'Biedingen zijn inclusief verkoopkosten (exclusief administratiekosten).',
  'client.popup.confirm': 'Ik heb het begrepen',
  'client.popup.header': 'Let op',
  'client.vehicle.kilometers': 'Km',
  'client.vehicle.lot_number': 'Nr.',
  'client.vehicle.new_price': 'Nieuwprijs',
  'client.vehicle.observations': 'Observeringen',
  'client.vehicle.options': 'Uitrusting(en)',
  'client.vehicle.quote': 'Notering',
  'client.vehicle.vat': 'BTW',
  'client.vehicle.localisation': 'Locatie',
  'client.video.live_sale': 'Bekijk de live verkoop',
  'loading.app': 'Een ogenblik geduld, er wordt verbinding gemaakt... ',
  'loading.sale': 'Bezig met laden van de verkoop...',
  'loading.vehicle': 'Bezig met laden van voertuig...',
  'next_sale.content.links.catalog': 'Verkoopcatalogus',
  'next_sale.content.links.sale_hours': 'Tijdstip van verkoop',
  'next_sale.content.paused': '<bold>Verkoop</bold> gepauseerd',
  'next_sale.content.restored_in': '<bold>Heropening</bold> binnen',
  'next_sale.content.timer.hours': `{hour, plural,
      =0 {Uur}
      =1 {Uur}
      other {Uur}
    }`,
  'next_sale.content.timer.minutes': `{minute, plural,
      =0 {Minuut}
      =1 {Minuut}
      other {Minuten}
    }`,
  'next_sale.footer.access': '<bold>Toegang</bold> kiezen',
  'next_sale.footer.guide': '<bold>Handleiding</bold> van Live',
  'next_sale.footer.main_site': '<bold>Terug</bold> naar VPauto',
  'next_sale.footer.planning': '<bold>Planning</bold> van volgende Live',
  'next_sale.footer.sound': '<bold>Verkoop</bold> beluisteren',
  'next_sale.footer.sound_instructions': 'Deze functie is momenteel niet beschikbaar.',
  'next_sale.header.live_from': '@:client.header.live_from',
}
